import {
  MedicareEnrollmentType,
  MedigapEnrollmentType,
  PdpEnrollmentType,
  PlanYear
} from '@coverright/data-access/types/enrollment';
import _ from 'lodash';
import moment from 'moment/moment';
import { isEffectiveDateValid } from '@coverright/utils';

export const getEnrollmentTypeTitle = (type: MedicareEnrollmentType): string => ({
  [MedicareEnrollmentType.MaNew]: 'MA - New-to-CMS',
  [MedicareEnrollmentType.MaUnlikeChange]: 'MA - Unlike plan change / Yr 1 Change',
  [MedicareEnrollmentType.MaReplacement]: 'MA - Replacement / \'Like\' plan change'
}[type])

export const getEnrollmentTypeSubtitle = (type: MedicareEnrollmentType): string => ({
  [MedicareEnrollmentType.MaNew]: 'New enrollments (i.e., age-in, New to Medicare, or enrolls from Orignal Medicare getting MA for first time)',
  [MedicareEnrollmentType.MaUnlikeChange]: 'PDP > MAPD or MAPD > PDP // PDP > PDP or MAPD > MAPD (Yr 1 Change)',
  [MedicareEnrollmentType.MaReplacement]: 'Like plan change in Year 2+'
}[type])

export const getEnrollmentTypeDescription = (type: MedicareEnrollmentType): string => ({
  [MedicareEnrollmentType.MaNew]: 'Initial Commissions is paid for the first year product is in effect, followed by Renewal Rate Commission in subsequent calednar years (monthly basis)',
  [MedicareEnrollmentType.MaUnlikeChange]: 'Commission on original Medicare Product will be charged back according to Rapid Disenrollment of LT Disenrollment.  Inital Commission is paid on a pro-rated basis based on effective date.  Renewal Rate Commission is paid in subsequent calendar years',
  [MedicareEnrollmentType.MaReplacement]: 'Commission on original Medicare Product will be charged back according to Rapid Disenrollment of LT Disenrollment. Renewal Rate Commission is paid on a pro-rated basis based on effective date and then Renewal Rate Commission is paid in subsequent calendar years'
}[type])


export const getMgEnrollmentTypeTitle = (type: MedigapEnrollmentType): string => ({
  [MedigapEnrollmentType.MgOep]: 'MG - OEP',
  [MedigapEnrollmentType.MgUnderwritten]: 'MG - Underwritten',
  [MedigapEnrollmentType.MgGi]: 'MG - GI',
}[type])

export const getMgEnrollmentTypeSubTitle = (type: MedigapEnrollmentType): string => ({
  [MedigapEnrollmentType.MgGi]: 'Enrolling in Medigap during a Guaranteed Issue period (e.g., Birthday Rule (CA), continuous guaranteed States (NY, CT, MA) or other GI period)',
  [MedigapEnrollmentType.MgOep]: 'Enrolling in Medigap within first 6 months of obtaining Part B',
  [MedigapEnrollmentType.MgUnderwritten]: 'Enrolling in Medigap with OEP or GI eligiblity'
}[type])

export const adjustAge = _.memoize(
  (initialAge: string, birthDate: string | null, effectiveDate: string | null) => {
    const eligibleDate = moment.utc(birthDate).add(65, 'years');
    const diff = moment.duration(eligibleDate.diff(effectiveDate)).asDays();
    let age = parseFloat(initialAge);
    if (diff < 31 && diff > 0) {
      age = 65
    }
    return age;
  }
)

export function getAgeOnEffectiveDate(birthday: string, effectiveDate?: string): number {
  return Math.floor(moment.duration(moment(effectiveDate).diff(moment(birthday))).asYears())
}

export function getPlanYearByEffectiveDate(effectiveDate: string): PlanYear | undefined {
  if (isEffectiveDateValid(effectiveDate)) {
    let year = moment(effectiveDate).year();
    if (year < 2021 || year > 2026) {
      year = 2026;
    }
    return 'Year' + year as PlanYear;
  }
  return undefined;
}



export const getPdpEnrollmentTypeSubTitle = (type: PdpEnrollmentType): string => ({
  [PdpEnrollmentType.PdpNew]: 'New enrollments (i.e., age-in, New to Medicare, or enrolls from Orignal Medicare getting MA for first time)',
  [PdpEnrollmentType.PdpUnlikeChange]: 'PDP > MAPD or MAPD > PDP // PDP > PDP or MAPD > MAPD (Yr 1 Change)',
  [PdpEnrollmentType.PdpReplacement]: 'Like plan change in Year 2+'
}[type])

export const getPdpEnrollmentTypeTitle = (type: PdpEnrollmentType): string => ({
  [PdpEnrollmentType.PdpNew]: 'PDP - New-to-CMS',
  [PdpEnrollmentType.PdpUnlikeChange]: 'PDP - Unlike plan change / Yr 1 change',
  [PdpEnrollmentType.PdpReplacement]: 'PDP - Replacement / \'Like\' Plan Change'
}[type])

export const getPdpEnrollmentTypeDescription = (type: PdpEnrollmentType): string => ({
  [PdpEnrollmentType.PdpNew]: 'Initial Commissions is paid for the first year product is in effect, followed by Renewal Rate Commission in subsequent calednar years (monthly basis)',
  [PdpEnrollmentType.PdpUnlikeChange]: 'Commission on original Medicare Product will be charged back according to Rapid Disenrollment of LT Disenrollment.  Inital Commission is paid on a pro-rated basis based on effective date.  Renewal Rate Commission is paid in subsequent calendar years',
  [PdpEnrollmentType.PdpReplacement]: 'Commission on original Medicare Product will be charged back according to Rapid Disenrollment of LT Disenrollment. Renewal Rate Commission is paid on a pro-rated basis based on effective date and then Renewal Rate Commission is paid in subsequent calendar years'
}[type])
